<template>
  <div id="file-drag-drop" v-tooltip="{
      content: $t(errors),
      placement: 'top-center',
      classes: ['info'],
      targetClasses: ['it-has-a-tooltip'],
      offset: 0,
      delay: {
        show: 500,
        hide: 300,
      },
      show: status === 'KO',
      trigger: 'manual'
    }">
    <form ref="fileform">
      <label for="files_id">
        <!--i class="material-icons md-36">note_add</i-->
        <input name="upload" id="files_id" type="file"
               :accept=acceptedFileTypes
               v-on:change="fileChosen">
        <strong>{{ $t('uploads.click') }}</strong>
        <span>{{ $t('uploads.drag') }}</span>
      </label>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import VTooltip from 'v-tooltip'
import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.use(VTooltip)
// Prevent conflict with Bootstrap tooltip
VTooltip.options.defaultTemplate = `<div class="v-tooltip" role="tooltip">
  <div class="v-tooltip-arrow"></div><div class="tooltip-inner"></div>
</div>`

export default {
  name: 'Upload',
  props: {
    acceptedFileTypes: {
      type: String,
      required: false
    },
    maxFileSize: {
      type: Number,
      required: false
    },
    postUploadHandler: {
      type: Function,
      required: false
    },
    url: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      errors: '',
      fileData: null,
      droppedFiles: [],
      status: 'OK'
    }
  },
  methods: {
    _checkDragAndDropUpload () {
      let ok = true
      const div = document.createElement('div')
      if (!(('draggable' in div) || ('ondragstart' in div && 'ondrop' in div))) {
        ok = false
        // console.error('Drag and drop is not available')
      }
      if (!('FormData' in window)) {
        ok = false
        // console.error('FormData is not available')
      }
      if (!('FileReader' in window)) {
        ok = false
        // console.error('FileReader is not available and thus DataTransfer')
      }
      return ok
    },
    fileChosen () {
      const form = document.querySelector('div#file-drag-drop form')
      this.fileData = new FormData(form)
      this.send()
    },
    send () {
      this.errors = ''
      this.status = 'OK'
      this.$http.post(this.url, this.fileData).then(
        response => response.json()).then((params) => {
        this.postUploadHandler(params, this.fileData)
        this.fileData = null
      }).catch(response => {
        this.fileData = null
        if (response.status === 400) {
          try {
            const err = response.json()
            if (err !== undefined) {
              this.errors = err.detail
              this.status = 'KO'
            }
          } catch (e) {
            this.errors = 'errors.general'
            this.status = 'KO'
          }
        } else if (response.status === 413 || response.status === 0) {
          this.errors = 'errors.file_too_big'
          this.status = 'KO'
        } else if (response.status === 500) {
          this.errors = 'errors.general'
          this.status = 'KO'
        }
      })
    }
  },
  mounted () {
    const that = this
    window.setTimeout(function () {
      if (that._checkDragAndDropUpload() === true) {
        const form = document.querySelector('div#file-drag-drop form')

        const prevDefaultEvents = function (e) {
          e.preventDefault()
          e.stopPropagation()
        }

        const addDragClass = function () {
          form.classList.add('is-dragover')
        }

        const removeDragClass = function () {
          form.classList.remove('is-dragover')
        }

        const events = 'drag dragstart dragend dragover dragenter dragleave drop'
        events.split(' ').forEach(function (e) {
          form.addEventListener(e, prevDefaultEvents, false)
        })

        const dragOnEvents = 'dragover dragenter'
        dragOnEvents.split(' ').forEach(function (e) {
          form.addEventListener(e, addDragClass, false)
        })

        const dragOffEvents = 'dragleave dragend drop'
        dragOffEvents.split(' ').forEach(function (e) {
          form.addEventListener(e, removeDragClass, false)
        })

        form.addEventListener('drop', function (e) {
          that.errors = ''
          that.status = 'OK'

          const files = e.dataTransfer.files
          that.fileData = new FormData(form)
          for (let i = 0; i < files.length; i++) {
            const file_ = files[i]
            that.fileData.append('upload', file_)
            if (file_.size > that.maxFileSize) {
              that.status = 'KO'
              that.errors = that.i18n('The file is too big')
            }
          }
          if (that.status === 'OK') {
            that.send()
          }
        })
      }
    }, 250)
  }
}
</script>

<style lang="scss">
$background-color: #fd8a6f;

@mixin linear-gradient($direction, $color-stops...) {
  // direction has been omitted and happens to be a color-stop
  @if is-direction($direction) == false {
    $color-stops: $direction, $color-stops;
    $direction: 180deg;
  }

  background: nth(nth($color-stops, 1), 1);
  background: -webkit-linear-gradient(legacy-direction($direction), $color-stops);
  background: linear-gradient($direction, $color-stops);
}

.gb-zb-widget-wrapper .v-tooltip {
  display: block !important;
  min-height: 20px;
  min-width: 240px;
  z-index: 1000000;

  .tooltip-inner {
    @include linear-gradient('0deg', #FC788D -30%, #FC8B70 70%);
    color: white;
    border-radius: 16px;
    font-family: 'Avenir', sans-serif;
    padding: 5px 10px 4px;
  }

  .v-tooltip-arrow {
    border-color: $background-color;
    border-style: solid;
    height: 0;
    margin: 5px;
    position: absolute;
    width: 0;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .v-tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .v-tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .v-tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .v-tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

.chawgt-webchat-form #file-drag-drop + button.gb-zb-upload {
  margin-right: 10px;
}

.chawgt-webchat-form form input[type="file"] {
  display: none;
}

.chawgt-webchat-form form.is-dragover {
  background-color: #EBEFF2;
}

.chawgt-webchat-form form i.material-icons {
  padding-top: 30px;
}

.chawgt-webchat-form strong {
  font-weight: 600;
}
</style>
